import * as Color from 'color';

import {useCSS} from '@pinecast/styles';

import type {Episode} from './models';
import PlaylistItem from './PlaylistItem';
import {useTheme} from './ThemeProvider';

type Props = {
  episodes: Array<Episode>;
  onSelect: (index: number) => void;
  selectedIndex: number;
};

const Playlist = ({episodes, selectedIndex, onSelect}: Props) => {
  const css = useCSS();
  const theme = useTheme();

  const secondaryColor = Color(theme.secondaryColor);
  const scrollbarColor = secondaryColor.isDark()
    ? secondaryColor.lighten(0.5).string()
    : secondaryColor.darken(0.5).string();

  return (
    <div
      className={css({
        backgroundColor: theme.secondaryColor,
        borderBottomLeftRadius: '6px',
        borderBottomRightxRadius: '6px',
        display: 'flex',
        flex: '1 1',
        flexDirection: 'column',
        overflowY: 'auto',
        padding: '6px 3px',
        scrollbarColor,
        scrollbarWidth: '8px',

        contain: 'strict',
        contentVisibility: 'auto',

        '::-webkit-scrollbar': {
          width: '8px',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: scrollbarColor,
          borderRadius: '4px',
          width: '8px',
        },
      })}
    >
      {episodes.map((episode, i) => (
        <PlaylistItem
          key={episode.id}
          episode={episode}
          onSelect={() => onSelect(i)}
          selected={i === selectedIndex}
        />
      ))}
    </div>
  );
};

export default Playlist;
